import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusDeviceSecretQueryVariables = Types.Exact<{
  purpose: Types.EpocusDeviceSecretPurpose;
}>;


export type EpocusDeviceSecretQuery = { readonly __typename?: 'Query', readonly epocusDeviceSecret: { readonly __typename?: 'EpocusDeviceSecret', readonly value: string } };


export const EpocusDeviceSecretDocument = gql`
    query EpocusDeviceSecret($purpose: EpocusDeviceSecretPurpose!) {
  epocusDeviceSecret(purpose: $purpose) {
    value
  }
}
    `;

/**
 * __useEpocusDeviceSecretQuery__
 *
 * To run a query within a React component, call `useEpocusDeviceSecretQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusDeviceSecretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusDeviceSecretQuery({
 *   variables: {
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useEpocusDeviceSecretQuery(baseOptions: Apollo.QueryHookOptions<EpocusDeviceSecretQuery, EpocusDeviceSecretQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusDeviceSecretQuery, EpocusDeviceSecretQueryVariables>(EpocusDeviceSecretDocument, options);
      }
export function useEpocusDeviceSecretLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusDeviceSecretQuery, EpocusDeviceSecretQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusDeviceSecretQuery, EpocusDeviceSecretQueryVariables>(EpocusDeviceSecretDocument, options);
        }
export type EpocusDeviceSecretQueryHookResult = ReturnType<typeof useEpocusDeviceSecretQuery>;
export type EpocusDeviceSecretLazyQueryHookResult = ReturnType<typeof useEpocusDeviceSecretLazyQuery>;
export type EpocusDeviceSecretQueryResult = Apollo.QueryResult<EpocusDeviceSecretQuery, EpocusDeviceSecretQueryVariables>;